import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsFormEditRoute: InvariantJiraRoute = {
	exact: true,
	name: 'helpcenter-settings-form-edit',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/forms/:formId',
};
